import {
	getCoreRowModel,
	getFacetedMinMaxValues,
	getFacetedRowModel,
	getFacetedUniqueValues,
	getFilteredRowModel,
	getGroupedRowModel,
	getSortedRowModel,
	useReactTable,
} from "@tanstack/react-table";
import { type FC } from "react";

import { AddRowButton } from "./AddRowButton";
import { CustomTable } from "./CustomTable";
import { DataGridHeader } from "./DataGridHeader";
import { type DataGridProps } from "./Props";
import { defaultColumn, fuzzyFilter } from "./tableModels";
import { useGetRowId } from "./useGetRowId";
import { useTableState } from "./useTanStackTableState";

export const DataGridAlphaV3: FC<DataGridProps<unknown, unknown>> = (props) => {
	const { materializedTableState, updateMaterializedTableState, reactTableOpts } =
		useTableState(props);

	const getRowId = useGetRowId(reactTableOpts.data);

	//
	// Table.
	//

	const table = useReactTable({
		defaultColumn,
		getRowId,
		getCoreRowModel: getCoreRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getGroupedRowModel: getGroupedRowModel(),
		getFacetedRowModel: getFacetedRowModel(),
		getFacetedUniqueValues: getFacetedUniqueValues(),
		getFacetedMinMaxValues: getFacetedMinMaxValues(),
		globalFilterFn: fuzzyFilter,
		// autoResetPageIndex,
		enableColumnResizing: true,
		enableRowSelection: true,
		columnResizeMode: "onChange",
		filterFns: { fuzzy: fuzzyFilter },
		...reactTableOpts,
		// debugTable: true,
		// debugHeaders: true,
		// debugColumns: true,
	});

	const allColumns = table.getAllLeafColumns();
	const grouped = allColumns.find((d) => d.getIsGrouped()) !== undefined;

	//
	// Render data grid.
	//

	return (
		<div className="group/table flex w-full flex-row">
			<DataGridHeader
				table={table}
				titleValue={materializedTableState.customState.title}
				onTitleValueChange={(value) =>
					updateMaterializedTableState({ customState: { title: value } })
				}
				searchQuery={materializedTableState.hookState?.globalFilter}
				onSearchQueryChange={(value) =>
					updateMaterializedTableState({ hookState: { globalFilter: value } })
				}
			/>
			{/* MAIN */}
			<div className="transition-none relative flex flex-col border border-transparent rounded-md z-component-flat mt-12 group-focus/compute-cell:border-brand group-focus/compute-cell:ring-4 group-focus/compute-cell:ring-default group-focus/compute-cell:shadow-md group-[.prosemirror-compute-cell--selected]:border-brand group-[.prosemirror-compute-cell--selected]:shadow-md">
				<CustomTable
					table={table}
					tableGroup={"center"}
					tableVariant={"default"}
					grouped={grouped}
				/>
				{!grouped &&
					props?.addNewRowButton !== false &&
					reactTableOpts.meta?.tableEditable !== false && (
						<AddRowButton table={table} insertRow={reactTableOpts.meta?.insertRow} />
					)}
			</div>
		</div>
	);
};
